import Styled from 'styled-components';
import React, {useEffect, useState} from 'react';

const Message = Styled.div`
	display: flex;
	width: 600px;
	height: 42px;
	background-color: #FFECB4;
	align-self: center;
	align-items: center;
	font-size: 13px;
	margin-top: 16px;
	padding-left: 16px;
	span {
		font-weight: bold;
		padding-right: 10px;
	}
`;

/**
 * @deprecated, should be removed when old budget v2 is removed. This file is copied
 * to FixedPriceUpdateToast.js
 */
function financialServiceAvailabilityToast() {
	const [timeLeft, setTimeLeft] = useState(120);

	useEffect(() => {
		const interval = setInterval(() => {
			if (timeLeft <= 0) {
				location.reload();
			} else {
				setTimeLeft(timeLeft - 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [timeLeft]);

	return (
		<Message>
			<span>Can't show data due to a system update, this could take 2-10 min.</span> – Page will refresh in {timeLeft}
		</Message>
	);
}

export default financialServiceAvailabilityToast;
